import { render } from "./Main.vue?vue&type=template&id=19820ebe"
const script = {}
script.render = render

export default script